import {
  errorAction,
  requestAction,
  successAction,
  types,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: [],
};

const serviceApplicationTags = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_SERVICE_APPLICATION_TAGS):
      return {
        ...state,
        loading: false,
      };
    case successAction(types.GET_SERVICE_APPLICATION_TAGS):
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    case requestAction(types.GET_SERVICE_APPLICATION_TAGS):
      return {
        ...state,
        data: [],
        loading: true,
      };
    default:
      return state;
  }
};

export default serviceApplicationTags;
